import PropTypes from 'prop-types'
import { MdClose } from 'react-icons/md'

import styles from './MergeCallPicker.module.scss'

// Lists the other calls the active call can be merged with (iOS CallsSlotView).
// `calls` items need `callerId` and `caller`; `isOnHold` only affects styling.
const MergeCallPicker = ({ calls, onMerge, onClose }) => {
  return (
    <div className={styles.wrapper}>
      <header className={styles.header}>
        <span className={styles.title}>Merge with</span>
        <span className={styles.closeIcon} onClick={onClose}>
          <MdClose />
        </span>
      </header>
      <div className={styles.list}>
        {calls.length ? (
          calls.map((call) => (
            <div
              key={call.callerId}
              className={`${styles.item} ${call.isOnHold ? styles.onHold : ''}`}
              onClick={() => onMerge(call)}
            >
              <span className={styles.name}>{call.caller || call.callerId}</span>
              {call.isOnHold ? <span className={styles.badge}>HOLD</span> : null}
            </div>
          ))
        ) : (
          <span className={styles.empty}>No other calls</span>
        )}
      </div>
    </div>
  )
}

MergeCallPicker.propTypes = {
  calls: PropTypes.arrayOf(
    PropTypes.shape({
      callerId: PropTypes.string,
      caller: PropTypes.string,
      isOnHold: PropTypes.bool,
    }),
  ).isRequired,
  onMerge: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default MergeCallPicker
